var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M10 8V4h4v4a2 2 0 1 1-4 0zM8 4v4a2 2 0 1 1-4 0V4h4zm4 8a3.99 3.99 0 0 1-3-1.354 3.99 3.99 0 0 1-4 1.228V20h4v-4a3 3 0 1 1 6 0v4h4v-8.126a4.01 4.01 0 0 1-4-1.228A3.99 3.99 0 0 1 12 12zm2 10h5a2 2 0 0 0 2-2v-9a1 1 0 0 0-.047-.302A3.985 3.985 0 0 0 22 8V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v4c0 1.04.397 1.986 1.047 2.698A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2h9zm-1-2v-4a1 1 0 1 0-2 0v4h2zm3-16v4a2 2 0 1 0 4 0V4h-4z" })
  );
});